export const iconFontAwesomeMedicalHealthFlaskVial = (
	<i className="fa-solid fa-flask-vial"></i>
);
